module.exports = __webpack_public_path__ + "static/media/welded200x200.39afe7f2.PNG";